import { render, staticRenderFns } from "./StatusLegend.vue?vue&type=template&id=7fb949bc&scoped=true&"
import script from "./StatusLegend.vue?vue&type=script&lang=js&"
export * from "./StatusLegend.vue?vue&type=script&lang=js&"
import style0 from "./StatusLegend.vue?vue&type=style&index=0&id=7fb949bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb949bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fb949bc')) {
      api.createRecord('7fb949bc', component.options)
    } else {
      api.reload('7fb949bc', component.options)
    }
    module.hot.accept("./StatusLegend.vue?vue&type=template&id=7fb949bc&scoped=true&", function () {
      api.rerender('7fb949bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Status/StatusLegend.vue"
export default component.exports